export const Urls = {
    GetDataTypes: "SurvivorshipRule/GetDataTypes",
    GetSurvivorshipRules: "SurvivorshipRule/GetSurvivorshipRules",
    SaveSurvivorshipRules: "SurvivorshipRule/SaveSurvivorshipRules"
};
